export default __webpack_public_path__ + "static/media/landing-page-1.401b4d4d.jpg";